import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { AgentProfileId, AgentVisibilitySettingsDto } from '@workspace/data-types';
import { environment } from '@workspace/ng-config';

@Component({
  selector: 'etxe-agent-visibility-display',
  imports: [MatIconModule, MatTooltipModule, RouterLink],
  templateUrl: './agent-visibility-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentVisibilityDisplayComponent {
  readonly settings = input<AgentVisibilitySettingsDto | undefined>(undefined);
  readonly agentProfileId = input<AgentProfileId | null | undefined>(null);

  readonly publicProfileUrl = computed(() => {
    const id = this.agentProfileId();
    if (!id) return null;
    const base = (environment.apps?.publicUrl || '').replace(/\/$/, '');
    return `${base}/agents/${id}`;
  });

  readonly resolved = computed(() => {
    const s = this.settings();
    return {
      isPublic: s?.isPublic ?? true,
      isVacationMode: s?.isVacationMode ?? false,
      allowSearchIndexing: s?.allowSearchIndexing ?? true,
    };
  });
}
